import Footer from "../components/footer";
import Navbar from "../components/navbar";
import VacancyJob from "../components/vacancyJob";

function ListJobPage() {
  return (
    <>
      <div className="max-w-screen-xl  mx-auto pt-20 flex-col bg-fixed">
        <Navbar>
          <VacancyJob />
          <Footer />
        </Navbar>
      </div>
    </>
  );
}
export default ListJobPage;
